import { useTranslation } from 'react-i18next';
import { Edit2, Trash } from 'iconsax-react';
import CustomTable from '../../../../components/atoms/CustomTable';
import { useGetPromotionDefaultContentsQuery } from '../../../../store/services/promotionsService';
import { PromotionDefaultContent } from '../../../../types/promotionDefaultContents';

interface DefaultBannersTableProps {
  marketplaceScopeCode: string;
  onEdit: (banner: PromotionDefaultContent) => void;
  onDelete: (banner: PromotionDefaultContent) => void;
}

export default function DefaultBannersTable({
  marketplaceScopeCode,
  onEdit,
  onDelete,
}: DefaultBannersTableProps) {
  const { t } = useTranslation();
  const { data, isFetching } = useGetPromotionDefaultContentsQuery({
    marketplaceScopeCode,
  });


  const columns = [
    {
      title: t('home.added-by', 'Added by'),
      dataIndex: 'createdBy',
      key: 'addedBy',
      render: (createdBy: any, record: PromotionDefaultContent) => {
        if (createdBy?.firstName || createdBy?.lastName) {
          return `${createdBy.firstName || ''} ${createdBy.lastName || ''}`.trim();
        }
        if (createdBy?.name) return createdBy.name;
        if (record.addedBy) return record.addedBy;
        return '—';
      },
    },
    {
      title: t('home.priority', 'Priority'),
      dataIndex: 'priority',
      key: 'priority',
    },
    {
      title: t('home.action', 'Action'),
      key: 'action',
      align: 'center' as const,
      render: (_: any, record: PromotionDefaultContent) => (
        <div
          className="flex items-center justify-center gap-3"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => onEdit(record)}
            className="w-8 h-8 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-600 flex items-center justify-center transition-colors"
          >
            <Edit2 size={16} variant="Bold" />
          </button>
          <button
            onClick={() => onDelete(record)}
            className="w-8 h-8 rounded-lg bg-red-50 hover:bg-red-100 text-red-600 flex items-center justify-center transition-colors"
          >
            <Trash size={16} variant="Bold" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full">
      <style>{`
        .default-banners-table .ant-table-thead > tr > th {
          background-color: #ffffff !important;
          border-bottom: 1px solid #f0f0f0 !important;
          color: #111928 !important;
          font-weight: 700 !important;
        }
        .default-banners-table .ant-table-tbody > tr > td {
          border-bottom: 1px solid #f0f0f0 !important;
          color: #4B5563 !important;
        }
        .default-banners-table .ant-table-tbody > tr:last-child > td {
          border-bottom: none !important;
        }
      `}</style>
      <CustomTable
        className="default-banners-table"
        columns={columns}
        dataSource={data?.payload || []}
        loading={isFetching}
        pagination={false}
        currentPage={1}
        totalElements={data?.payload?.length || 0}
        onPageChange={() => {}}
        rowKey="id"
      />
    </div>
  );
}
